const PEAKWAVE_ORIGIN = "https://peakwave.co";
const COMPANION_URL = `${PEAKWAVE_ORIGIN}/companion`;
const ALLOWED_ROUTE_PREFIXES = ["/companion", "/conditions", "/call", "/calls", "/briefings"];
const LOOPBACK_NATIVE_HOSTS = new Set(["localhost", "127.0.0.1", "10.0.2.2", "::1", "[::1]"]);

function isAllowedRoute(pathname) {
  return ALLOWED_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

function customSchemePath(url) {
  const hostSegment = url.hostname ? `/${url.hostname}` : "";
  return `${hostSegment}${url.pathname || ""}` || "/";
}

function webUrlForPath(pathname, search, hash, allowDevelopmentOrigins) {
  const searchParams = new URLSearchParams(search);
  const nativeOrigin = allowDevelopmentOrigins
    ? nativeOriginOverride(searchParams.get("native-origin"))
    : null;
  searchParams.delete("native-origin");

  const target = new URL(pathname, nativeOrigin ?? PEAKWAVE_ORIGIN);
  const cleanedSearch = searchParams.toString();
  target.search = cleanedSearch ? `?${cleanedSearch}` : "";
  target.hash = hash;
  return target.toString();
}

function nativeOriginOverride(rawOrigin) {
  if (!rawOrigin) return null;

  try {
    const origin = new URL(rawOrigin);
    const loopback = LOOPBACK_NATIVE_HOSTS.has(origin.hostname);
    if (!loopback || origin.username || origin.password || (origin.protocol !== "http:" && origin.protocol !== "https:")) {
      return null;
    }
    return origin.origin;
  } catch {
    return null;
  }
}

export function appUrlFromLaunch(rawUrl, { allowDevelopmentOrigins = false } = {}) {
  try {
    const url = new URL(rawUrl);
    if (url.username || url.password) return null;

    if (url.protocol === "peakwave:" && !url.port) {
      const pathname = customSchemePath(url);
      return isAllowedRoute(pathname)
        ? webUrlForPath(pathname, url.search, url.hash, allowDevelopmentOrigins)
        : null;
    }

    if (url.origin === PEAKWAVE_ORIGIN && isAllowedRoute(url.pathname)) {
      return webUrlForPath(url.pathname, url.search, url.hash, false);
    }
  } catch {
    return null;
  }

  return null;
}

export function resolveLaunchUrl(rawUrl, options = {}) {
  return appUrlFromLaunch(rawUrl, options) ?? COMPANION_URL;
}
